export default {
  SET_RECEIVED_EMAILS_LIST(state, { pages, itemsPerPage, emails = [] }) {
    state.receivedEmails = emails;
    state.pages = pages;
    state.itemsPerPage = itemsPerPage;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_SELECTED_EMAIL(state, email) {
    state.selectedEmail = email;
  },
  SET_SHOW_EMAIL_VIEWER(state, show) {
    state.showEmailViewer = show;
  },
  SET_PAGE(state, { page }) {
    state.page = page;
  },
  SET_ITEM_PER_PAGE(state, { items, page }) {
    state.itemsPerPage = items;
    state.page = page;
  },
  SET_FILTERS(state, filters) {
    state.filters = filters;
  }
};
